<template>
  <v-main class="grey lighten-2">
    <router-view />
  </v-main>
</template>

<script>
export default {};
</script>